import type { FC } from "react";

import { useTranslations } from "@ui/providers/useTranslations";

import { AlertBanner } from "@jti/core-components/components/AlertBanner";

import { SobQuestion } from "./SobQuestion";
import type { QuizData } from "./SobQuiz.types";
import { useQuiz } from "./useQuiz";

export interface SobQuizProps {
  data: QuizData;
}

export const SobQuiz: FC<SobQuizProps> = ({ data }) => {
  const { __ } = useTranslations();
  const { state, currentQuestion, isLoading, handleConsent, handleAnswer, consentData } = useQuiz(data);
  const { consentCaptureQuestion, questionScreen, finalScreen } = data;
  const { title: consentTitle, description: consentDescription } = consentCaptureQuestion;

  if (state.value === "declined" || !state.value) {
    return null;
  }

  return (
    <div data-testid="sob-quiz">
      {state.value === "consent" && (
        <SobQuestion
          isPending={isLoading}
          question={{
            question: { id: "consent", title: consentData ? consentData.description : "" },
            possibleAnswers: [
              { id: "yes", title: __("sob.consent.yes"), referenceName: "", localTranslation: __("sob.consent.yes") },
              { id: "no", title: __("sob.consent.no"), referenceName: "", localTranslation: __("sob.consent.no") },
            ],
          }}
          title={consentTitle}
          description={consentDescription}
          onAnswerSelect={(answerId) => {
            handleConsent(answerId === "yes");
          }}
        />
      )}

      {state.value === "quiz" && currentQuestion && (
        <SobQuestion
          isPending={isLoading}
          question={{
            question: currentQuestion.question,
            possibleAnswers: currentQuestion.possibleAnswers,
          }}
          title={questionScreen.title}
          description={questionScreen.description}
          onAnswerSelect={handleAnswer}
        />
      )}

      {state.value === "completion" && (
        <AlertBanner
          tone="success"
          title={finalScreen.title}
          description={`${finalScreen?.description} ${finalScreen?.topic ?? ""}`}
        />
      )}
    </div>
  );
};
